// extracted by mini-css-extract-plugin
export default {"nameRow":"AboutYourself_nameRow__kfPf3","inputGroup":"AboutYourself_inputGroup__5txzh","label":"AboutYourself_label__sEGof","input":"AboutYourself_input__ZDSQK"};